import { render, staticRenderFns } from "./UpdateReportArchiveCompare.vue?vue&type=template&id=0db87688&"
import script from "./UpdateReportArchiveCompare.vue?vue&type=script&lang=js&"
export * from "./UpdateReportArchiveCompare.vue?vue&type=script&lang=js&"
import style0 from "./UpdateReportArchiveCompare.vue?vue&type=style&index=0&id=0db87688&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VSpacer,VTextField,VTooltip})
